import React, { useState, useEffect, useRef } from 'react';
import ThreeTop from './Topbar';
import FilterSidebar from './Filtersidebar';
import './BlogPage.css';
import BlogGrid from './Bloggrid';
import searchIcon from "../../assets/Search.svg";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { getWithoutTokenAPI } from "../../util/Api";
import AOS from "aos";
import "aos/dist/aos.css";

const AllCategoriesPage = () => {
  const navigate = useNavigate();
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [allProducts, setAllProducts] = useState([]);
  const searchRef = useRef(null);

  const toggleFilter = () => {
    setIsFilterVisible(prev => !prev);
  };


useEffect(() => {
  AOS.init({ duration: 800, once: true });
}, []);

  // Fetch all products on component mount
  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        const response = await getWithoutTokenAPI('/blog/find-all');
        if (response?.statusCode === 200 && response.data?.blogs) {
          setAllProducts(response.data.blogs);
        } else {
          toast.error("Failed to load blogs");
        }
      } catch (error) {
        console.error("Error fetching all blogs:", error);
        toast.error("Failed to load blogs");
      }
    };
    fetchAllProducts();
  }, []);

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Filter products based on search text
  useEffect(() => {
    if (searchText.trim().length < 2) {
      setSuggestions([]);
      return;
    }

    const searchTerm = searchText.toLowerCase();
    const filteredProducts = allProducts.filter(blog => 
      blog?.title?.toLowerCase().includes(searchTerm) ||
      blog?.subtitle?.toLowerCase().includes(searchTerm) ||
      blog?.tags?.some(tag => tag?.name?.toLowerCase().includes(searchTerm)) ||
      blog?.categories?.some(category => category?.category_name?.toLowerCase().includes(searchTerm))
    );

    setSuggestions(filteredProducts.slice(0, 10));
    setShowSuggestions(true);
  }, [searchText, allProducts]);

  const handleSearch = async () => {
    if (!searchText.trim()) {
      toast.warning("Please enter a search term");
      return;
    }

    setIsSearching(true);
    try {
      const response = await getWithoutTokenAPI(`/blog/find-all?search_text=${encodeURIComponent(searchText)}`);
      
      if (response?.statusCode === 200 && response.data?.blogs) {
        navigate('/search-results', { 
          state: { 
            searchResults: response.data.blogs, 
            searchTerm: searchText,
            totalCount: response.data.total_count
          } 
        });
      } else {
        toast.error("No results found");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred while searching");
    } finally {
      setIsSearching(false);
      setShowSuggestions(false);
    }
  };

  const handleSuggestionClick = (blog) => {
    if (!blog?._id) {
      toast.error("Invalid blog selected");
      return;
    }
    setSearchText(blog.title || '');
    setShowSuggestions(false);
    navigate(`/blog?_id=${blog._id}`);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = '/placeholder.png';
  };

  return (
    // <div className="all-categories-wrapper">
    //   <ToastContainer autoClose={3000} />
    //   <ThreeTop toggleFilter={toggleFilter} />
    //   <div className='input-contant m-4'>
    //     <div className="input-box" ref={searchRef}>
    //       <img src={searchIcon} alt="search" className="search-icon" />
    //       <input 
    //         placeholder="Search blogs" 
    //         type="text" 
    //         value={searchText}
    //         onChange={(e) => setSearchText(e.target.value)}
    //         onKeyPress={handleKeyPress}
    //         onFocus={() => searchText.length >= 2 && setShowSuggestions(true)}
    //       />
          
    //       {showSuggestions && suggestions.length > 0 && (
    //         <div className="suggestions-dropdown">
    //           {suggestions.map((blog) => (
    //             <div
    //               key={blog._id}
    //               className="suggestion-item"
    //               onClick={() => handleSuggestionClick(blog)}
    //             >
    //               <div className="suggestion-image-container">
    //                 <img 
    //                   src={blog?.images?.[0] || '/placeholder.png'}
    //                   alt={blog?.title || 'Blog'}
    //                   className="suggestion-image"
    //                   onError={handleImageError}
    //                 />
    //               </div>
    //               <div className="suggestion-details">
    //                 <span className="suggestion-name">{blog?.title || 'Untitled Blog'}</span>
    //                 <div className="suggestion-meta">
    //                   <span className="suggestion-category">
    //                     {blog?.categories?.[0]?.category_name || 'Uncategorized'}
    //                   </span>
    //                   {blog?.tags?.length > 0 && (
    //                     <span className="suggestion-tag">{blog.tags[0].name}</span>
    //                   )}
    //                 </div>
    //               </div>
    //             </div>
    //           ))}
    //         </div>
    //       )}
    //     </div>
    //   </div>
    //   <div className='center-card'>
    //     <div className="main-content">
    //       <BlogGrid/>
    //     </div>
    //   </div>
    // </div>

    <div className="all-categories-wrapper">
  <ToastContainer autoClose={3000} />

  <div data-aos="fade-down" data-aos-delay="100">
    <ThreeTop toggleFilter={toggleFilter} />
  </div>

  <div className='input-contant m-4' data-aos="zoom-in" data-aos-delay="200">
    <div className="input-box" ref={searchRef}>
      <img src={searchIcon} alt="search" className="search-icon" />
      <input 
        placeholder="Search blogs" 
        type="text" 
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onKeyPress={handleKeyPress}
        onFocus={() => searchText.length >= 2 && setShowSuggestions(true)}
      />

      {showSuggestions && suggestions.length > 0 && (
        <div className="suggestions-dropdown" data-aos="fade-up" data-aos-delay="300">
          {suggestions.map((blog) => (
            <div
              key={blog._id}
              className="suggestion-item"
              onClick={() => handleSuggestionClick(blog)}
              data-aos="fade-right"
              data-aos-delay="100"
            >
              <div className="suggestion-image-container">
                <img 
                  src={blog?.images?.[0] || '/placeholder.png'}
                  alt={blog?.title || 'Blog'}
                  className="suggestion-image"
                  onError={handleImageError}
                />
              </div>
              <div className="suggestion-details">
                <span className="suggestion-name">{blog?.title || 'Untitled Blog'}</span>
                <div className="suggestion-meta">
                  <span className="suggestion-category">
                    {blog?.categories?.[0]?.category_name || 'Uncategorized'}
                  </span>
                  {blog?.tags?.length > 0 && (
                    <span className="suggestion-tag">{blog.tags[0].name}</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>

  <div className='center-card'>
    <div className="main-content" data-aos="fade-up" data-aos-delay="300">
      <BlogGrid />
    </div>
  </div>
</div>

  );
};

export default AllCategoriesPage;
